export class CustomerSpecialProductList {    
    private params: any = {};

    activate(params) {        
        this.params.Id = params.Id
    }
}